import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b6ab7c70"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "streakCv",
  class: "nge-flight-streaks",
  "aria-hidden": "true"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-flight-corner nge-flight-corner--tl" }, null, -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-flight-corner nge-flight-corner--tr" }, null, -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-flight-corner nge-flight-corner--bl" }, null, -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-flight-corner nge-flight-corner--br" }, null, -1 /* HOISTED */))
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<svg viewBox=\"0 0 120 120\" width=\"120\" height=\"120\" data-v-b6ab7c70><circle cx=\"60\" cy=\"60\" r=\"26\" fill=\"none\" stroke=\"rgba(53,181,255,0.55)\" stroke-width=\"1.2\" data-v-b6ab7c70></circle><circle cx=\"60\" cy=\"60\" r=\"1.8\" fill=\"rgba(216,238,255,0.9)\" data-v-b6ab7c70></circle><path d=\"M60 22 v12 M60 86 v12 M22 60 h12 M86 60 h12\" stroke=\"rgba(53,181,255,0.75)\" stroke-width=\"1.4\" data-v-b6ab7c70></path><path d=\"M42 42 l6 6 M78 42 l-6 6 M42 78 l6 -6 M78 78 l-6 -6\" stroke=\"rgba(53,181,255,0.3)\" stroke-width=\"1\" data-v-b6ab7c70></path></svg>", 1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "nge-flight-top" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-flight-rec" }, null, -1 /* HOISTED */))
const _hoisted_10 = { class: "nge-flight-sub" }
const _hoisted_11 = { class: "nge-flight-speed" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-flight-key" }, "VEL", -1 /* HOISTED */))
const _hoisted_13 = {
  key: 0,
  class: "nge-flight-boost"
}
const _hoisted_14 = { class: "nge-flight-pos" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-flight-key" }, "POS", -1 /* HOISTED */))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-flight-hint" }, " W thrust · S retro · A/D strafe · R/F rise & dive · Q/E roll · Shift boost · Esc exit ", -1 /* HOISTED */))

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    ref: "rootEl",
    class: "nge-flight",
    onClick: $setup.engageSteering
  }, [
    _createElementVNode("canvas", _hoisted_1, null, 512 /* NEED_PATCH */),
    _createCommentVNode(" canopy frame "),
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _createCommentVNode(" reticle "),
    _createElementVNode("div", {
      class: _normalizeClass(["nge-flight-reticle", { 'nge-flight-reticle--hot': $setup.boosting }])
    }, _hoisted_7, 2 /* CLASS */),
    _createCommentVNode(" readouts "),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createTextVNode(" FLIGHT MODE "),
      _createElementVNode("span", _hoisted_10, _toDisplayString($setup.steering ? 'steering engaged' : 'click to steer'), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      _createTextVNode(" " + _toDisplayString($setup.speedLabel) + " ", 1 /* TEXT */),
      ($setup.boosting)
        ? (_openBlock(), _createElementBlock("span", _hoisted_13, "BOOST"))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _createTextVNode(" " + _toDisplayString($setup.posLabel), 1 /* TEXT */)
    ]),
    _hoisted_16,
    _createElementVNode("button", {
      class: "nge-flight-exit",
      title: "Power down (Esc)",
      onClick: _cache[0] || (_cache[0] = _withModifiers($event => ($setup.emit('hide')), ["stop"]))
    }, "✕")
  ], 512 /* NEED_PATCH */))
}